import { DatePickerAdapter } from 'components/enhanced/form/adapters/date-time/DatePickerAdapter';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { composeValidators, mustBeCurrency } from 'components/helpers/validators';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';
import { useAdditionalCostLayers } from '../../hooks/queries/useAdditionalCostLayers';

interface AdditionalEquipmentCostProps {
  onSubmit: any;
  equipments: Option[];
}

function AdditionalEquipmentCostForm(props: AdditionalEquipmentCostProps) {
  const { onSubmit } = props;
  const { t } = useTranslation();

  const [layerType, setLayerType] = useState<Option>({ id: null, code: null });
  const { layerTypes, layers } = useAdditionalCostLayers(layerType?.['model']);

  return (
    <EnhancedForm
      title={'Aggiungi Costo Aggiuntivo'}
      onSubmit={onSubmit}
      formId="addAdditionalCost"
      hideControls={false}
      autoStyleLayout={true}
      density="compact">
      <IdentityField name="code" component={TextFieldAdapter} label={t('global.id')} required />
      <IdentityField
        gridSpan={2}
        name="description"
        component={TextFieldAdapter}
        label={t('global.description')}
      />
      <IdentityField
        name="amount"
        label={t('global.amount')}
        component={TextFieldAdapter}
        type="text"
        validate={composeValidators(mustBeCurrency)}
      />
      <IdentityField name="date" label={t('global.date')} component={DatePickerAdapter} />
      <IdentityField
        gridSpan={3}
        name="content_type"
        component={AutocompleteAdapter}
        options={layerTypes}
        optionLabel="model"
        label={t('entities.cost_element.content_type')}
        type="number"
        setValue={setLayerType}
      />
      <IdentityField
        gridSpan={2}
        name="object_id"
        component={AutocompleteAdapter}
        options={layers}
        label={t('entities.cost_element.object_id')}
        type="number"
      />
    </EnhancedForm>
  );
}

export default AdditionalEquipmentCostForm;
